import { CompanySettingWorkingDay } from "domain-entities";
import { WorkingDaysKey } from "../types/WorkingDaysKey";

export function getWorkingDaysKey(
	workingDays?: CompanySettingWorkingDay[]
): WorkingDaysKey {
	const workingDaysString = (workingDays || [])
		.map((workingDay) => (workingDay.enabled ? "1" : "0"))
		.join("");

	switch (workingDaysString) {
		case "1111100":
			return "MoFr";
		case "1111110":
			return "MoSa";
		default:
			return "MoSu";
	}
}
